import React, { useState } from "react"
import { v4 as uuidv4 } from "uuid"

const ProductTable = () => {
  const [tires] = useState([
    {
      id: uuidv4(),
      tireSize: "4.00-8",
      rimSize: "3.00 D-8",
      clip: "*",
      profile: "GS",
      maxW: "104",
      od: "406",
      loadW: "950",
      steerW: "730",
    },
    {
      id: uuidv4(),
      tireSize: "5.00-8",
      rimSize: "3.00 D-8",
      clip: "*",
      profile: "GS",
      maxW: "116",
      od: "446",
      loadW: "1415",
      steerW: "1090",
    },
    {
      id: uuidv4(),
      tireSize: "15x4 1/2-8 (125/75-8)",
      rimSize: "3.00 D-8",
      clip: "*",
      profile: "GS",
      maxW: "103",
      od: "377",
      loadW: "1040",
      steerW: "800",
    },
    {
      id: uuidv4(),
      tireSize: "16x6-8 (150/75-8)",
      rimSize: "4.33 R-8",
      clip: "*",
      profile: "GS",
      maxW: "139",
      od: "407",
      loadW: "1455",
      steerW: "1150",
    },
    {
      id: uuidv4(),
      tireSize: "18x7-8 (180x7-8)",
      rimSize: "4.33 R-8",
      clip: "*",
      profile: "GS",
      maxW: "153",
      od: "451",
      loadW: "2145",
      steerW: "1650",
    },
    {
      id: uuidv4(),
      tireSize: "6.00-9",
      rimSize: "4.00 E-9",
      clip: "*",
      profile: "GS",
      maxW: "139",
      od: "520",
      loadW: "1885",
      steerW: "1450",
    },
    {
      id: uuidv4(),
      tireSize: "21x8-9 (200/75-9) ",
      rimSize: "6.00 E-9",
      clip: "*",
      profile: "GS",
      maxW: "174",
      od: "516",
      loadW: "2755",
      steerW: "2120",
    },
    {
      id: uuidv4(),
      tireSize: "6.50-10",
      rimSize: "5.00 F-10",
      clip: "*",
      profile: "GS",
      maxW: "153",
      od: "565",
      loadW: "2340",
      steerW: "1800",
    },
    {
      id: uuidv4(),
      tireSize: "200/50-10",
      rimSize: "6.50 F-10",
      clip: "*",
      profile: "GS",
      maxW: "188",
      od: "456",
      loadW: "2470",
      steerW: "1900",
    },
    {
      id: uuidv4(),
      tireSize: "23x9-10 (225/75-10)",
      rimSize: "6.50 F-10",
      clip: "*",
      profile: "GS",
      maxW: "188",
      od: "582",
      loadW: "3445",
      steerW: "2650",
    },
    {
      id: uuidv4(),
      tireSize: "7.00-12",
      rimSize: "5.00 S-12",
      clip: "*",
      profile: "GS",
      maxW: "164",
      od: "647",
      loadW: "2920",
      steerW: "2240",
    },
    {
      id: uuidv4(),
      tireSize: "23x10-12",
      rimSize: "8.00 G-12",
      clip: "*",
      profile: "GS",
      maxW: "234",
      od: "580",
      loadW: "3770",
      steerW: "2900",
    },
    {
      id: uuidv4(),
      tireSize: "27x10-12 (250/75-12)",
      rimSize: "8.00 G-12",
      clip: "*",
      profile: "GS",
      maxW: "232",
      od: "675",
      loadW: "3900",
      steerW: "3000",
    },
    {
      id: uuidv4(),
      tireSize: "7.00-15",
      rimSize: "5.50-15",
      clip: "*",
      profile: "GS",
      maxW: "175",
      od: "705",
      loadW: "3545",
      steerW: "2725",
    },
    {
      id: uuidv4(),
      tireSize: "7.00-15",
      rimSize: "6.00-15",
      clip: "*",
      profile: "GS",
      maxW: "175",
      od: "705",
      loadW: "3545",
      steerW: "2725",
    },
    {
      id: uuidv4(),
      tireSize: "250-15 (250/70-15)",
      rimSize: "7.00-15",
      clip: "*",
      profile: "GS",
      maxW: "211",
      od: "712",
      loadW: "4750",
      steerW: "3650",
    },
    {
      id: uuidv4(),
      tireSize: "250-15 (250/70-15)",
      rimSize: "7.50-15",
      clip: "*",
      profile: "GS",
      maxW: "211",
      od: "712",
      loadW: "4750",
      steerW: "3650",
    },
    {
      id: uuidv4(),
      tireSize: "8.15-15(28x9-15)  (225/75-15)",
      rimSize: "7.00-15",
      clip: "*",
      profile: "GS",
      maxW: "202",
      od: "681",
      loadW: "3770",
      steerW: "2900",
    },
    {
      id: uuidv4(),
      tireSize: "8.25-15",
      rimSize: "5-50-15",
      clip: "*",
      profile: "GS",
      maxW: "194",
      od: "809",
      loadW: "4750",
      steerW: "3650",
    },
    {
      id: uuidv4(),
      tireSize: "8.25-15",
      rimSize: "6.50-15",
      clip: "*",
      profile: "GS",
      maxW: "193",
      od: "809",
      loadW: "4750",
      steerW: "3650",
    },
    {
      id: uuidv4(),
      tireSize: "300-15 (315/70-15)",
      rimSize: "8.00-15",
      clip: "*",
      profile: "GS",
      maxW: "243",
      od: "812",
      loadW: "5850",
      steerW: "4500",
    },
    {
      id: uuidv4(),
      tireSize: "355/65-15",
      rimSize: "9.75-15",
      clip: "*",
      profile: "GS",
      maxW: "291",
      od: "826",
      loadW: "7800",
      steerW: "6000",
    },
    {
      id: uuidv4(),
      tireSize: "9.00-20",
      rimSize: "6.50-10",
      clip: " ",
      profile: "GS",
      maxW: "225",
      od: "971",
      loadW: "5340",
      steerW: "4450",
    },
    {
      id: uuidv4(),
      tireSize: "9.00-20",
      rimSize: "7.00-20",
      clip: " ",
      profile: "GS",
      maxW: "225",
      od: "971",
      loadW: "5340",
      steerW: "4450",
    },
    {
      id: uuidv4(),
      tireSize: "10.00-20",
      rimSize: "7.00-20",
      clip: " ",
      profile: "GS",
      maxW: "250",
      od: "1006",
      loadW: "6000",
      steerW: "5000",
    },
    {
      id: uuidv4(),
      tireSize: "10.00-20",
      rimSize: "7.50-20",
      clip: " ",
      profile: "GS",
      maxW: "250",
      od: "1006",
      loadW: "6000",
      steerW: "5000",
    },
    {
      id: uuidv4(),
      tireSize: "10.00-20",
      rimSize: "8.00-20",
      clip: " ",
      profile: "GS",
      maxW: "250",
      od: "1006",
      loadW: "6000",
      steerW: "5000",
    },
    {
      id: uuidv4(),
      tireSize: "11.00-20",
      rimSize: "7.50-20",
      clip: " ",
      profile: "GS",
      maxW: "265",
      od: "1088",
      loadW: "6540",
      steerW: "5450",
    },
    {
      id: uuidv4(),
      tireSize: "11.00-20",
      rimSize: "8.00-20",
      clip: " ",
      profile: "GS",
      maxW: "265",
      od: "1088",
      loadW: "6540",
      steerW: "5450",
    },
    {
      id: uuidv4(),
      tireSize: "11.00-20",
      rimSize: "8.50-20",
      clip: " ",
      profile: "GS",
      maxW: "265",
      od: "1088",
      loadW: "7500",
      steerW: "6250",
    },
    {
      id: uuidv4(),
      tireSize: "12.00-20",
      rimSize: "8.00-20",
      clip: " ",
      profile: "GS",
      maxW: "265",
      od: "1088",
      loadW: "7500",
      steerW: "6250",
    },
    {
      id: uuidv4(),
      tireSize: "12.00-20",
      rimSize: "8.50-20",
      clip: " ",
      profile: "GS",
      maxW: "265",
      od: "1088",
      loadW: "7500",
      steerW: "6250",
    },
  ])

  return (
    <div className="w-full mb-20 rounded-md shadow border-b border-gray-200 sm:rounded-lg overflow-x-auto md:overflow-x-hidden">
      <table className="w-full table-auto">
        <thead className="text-white text-center text-sm">
          <tr className="bg-blue-800 p-3">
            <th className="p-3" colSpan="1" rowSpan="4">
              Tire Size
            </th>
            <th className="p-3" colSpan="1" rowSpan="4">
              Rim Size
            </th>
            <th className="p-3" colSpan="1" rowSpan="4">
              Clip On
            </th>
            <th className="p-3" colSpan="1" rowSpan="4">
              Profile
            </th>
            <th className="p-3" colSpan="2" rowSpan="1">
              Tire Dimensions (Metric)
            </th>
            <th className="p-3" colSpan="2" rowSpan="1">
              Load Capacity (20 km/h kg)
            </th>
          </tr>
          <tr className="bg-blue-800 p-3">
            <th className="p-3" colSpan="1" rowSpan="3">
              Max Width (mm)
            </th>
            <th className="p-3" colSpan="1" rowSpan="3">
              OD (mm)
            </th>
          </tr>
          <tr className="bg-blue-800 p-3">
            <th className="p-3" colSpan="1" rowSpan="1">
              Load Wheel
            </th>
            <th className="p-3" colSpan="1" rowSpan="1">
              Steer Wheel
            </th>
          </tr>
        </thead>
        <tbody>
          {tires.map(tire => {
            return (
              <tr className="text-center" key={tire.id}>
                <td className="border-grey-light border hover:bg-gray-100 p-3">
                  {tire.tireSize}
                </td>
                <td className="border-grey-light border hover:bg-gray-100 p-3">
                  {tire.rimSize}
                </td>
                <td className="border-grey-light border hover:bg-gray-100 p-3">
                  {tire.clip}
                </td>
                <td className="border-grey-light border hover:bg-gray-100 p-3">
                  {tire.profile}
                </td>
                <td className="border-grey-light border hover:bg-gray-100 p-3">
                  {tire.maxW}
                </td>
                <td className="border-grey-light border hover:bg-gray-100 p-3">
                  {tire.od}
                </td>
                <td className="border-grey-light border hover:bg-gray-100 p-3">
                  {tire.loadW}
                </td>
                <td className="border-grey-light border hover:bg-gray-100 p-3">
                  {tire.steerW}
                </td>
              </tr>
            )
          })}
        </tbody>
      </table>
    </div>
  )
}

export default ProductTable
